import React from 'react';


const WelcomeHeader = ({ userName, subscriptionTier, usageStats }) => {
  // Component removed as per user request - glass overlay and greeting text deleted
  return null;
};

export default WelcomeHeader;